export enum EAPP_CHANNEL_VALUE {
  /** douyin miniapp */
  DOUYIN = 'DOUYIN',
  /** unionpay miniapp */
  UNIONPAY = 'UNIONPAY',
  /** default */
  H5 = 'H5',
}

/**
 * get current REACT_APP_CHANNEL value
 */
export const getAppChannelValue = () => {
  const _channel = process.env.REACT_APP_CHANNEL;
  switch (_channel) {
    case EAPP_CHANNEL_VALUE.DOUYIN:
    case EAPP_CHANNEL_VALUE.UNIONPAY:
    case EAPP_CHANNEL_VALUE.H5:
      return _channel;
    default:
      return EAPP_CHANNEL_VALUE.H5;
  }
};

export const isDouyinAppChannel = () => {
  return getAppChannelValue() === EAPP_CHANNEL_VALUE.DOUYIN;
};

export const isUnionPayAppChannel = () => {
  return getAppChannelValue() === EAPP_CHANNEL_VALUE.UNIONPAY;
};

export const isH5AppChannel = () => {
  return getAppChannelValue() === EAPP_CHANNEL_VALUE.H5;
};
